import React, { FC } from 'react';
import { TitleElem } from './Title.styles';

interface ITitle {
  className?: string;
  tag?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  title: string;
}

const Title: FC<ITitle> = ({ className, tag = 'h2', title }) => (
  <TitleElem as={tag} id="SectionTitle" {...{ className }}>
    {title}
  </TitleElem>
);

export default Title;
